import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=0386070c&scoped=true"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"
import style0 from "./CompanyView.vue?vue&type=style&index=0&id=0386070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386070c",
  null
  
)

export default component.exports